import React from 'react';
const Vpscloud = () => {
  return(
<>
    <div className="bg">
        <div className="container">
            <h1 className="fs-1 text-center pt-5">Cloud Virtual Private Servers</h1>
            <p className="text-center">Flexible VPS hosting platform to deploy your online projects. Economical and balanced between processor cores, memory, and storage. Many linux (open source) templates available to choose from. We also have windows virtual private servers available here. If you are looking for lots of storage check out large storage optimized VPS.</p>
            <div className="row mt-5">
                <div className="col-md-3 text-center" data-aos="fade-up" data-aos-delay="100">
                    <div className="shadow pb-5">
                        <div className ="text-center bg-color">
                            <p className="fs-4 fw-bold text-center text-white  p-3 fs-3">1 Slice</p>
                        </div>
                        <p className="color text-center"><span className="fw-bold fs-1">$3.00</span>/mo</p>
                        <ul className="p-0 text-center m-0">
                            <li><span>1</span> Cores</li>
                            <li><span> 2GB </span> Memory </li>
                            <li><span> 40GB</span> SSD Storage</li>
                            <li><span>2TB</span> Transfer</li>
                            <li><span>10Gbps</span> Shared Port</li>
                        </ul>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className=' p-5'>Contact Us</a></button>
                    </div>
                </div>
                <div className="col-md-3 text-center" data-aos="fade-up" data-aos-delay="300">
                    <div className="shadow pb-5">
                        <div className ="text-center bg-color">
                            <p className="fs-4 fw-bold text-center text-white p-3 fs-3">2 Slices</p>
                        </div>
                        <p className="color text-center"><span className="fw-bold fs-1">$6.00</span>/mo</p>
                        <ul className="p-0 text-center m-0">
                            <li><span>1</span> Cores</li>
                            <li><span> 4GB </span> Memory </li>
                            <li><span> 80GB</span> SSD Storage</li>
                            <li><span>4TB</span> Transfer</li>
                            <li><span>10Gbps</span> Shared Port</li>
                        </ul>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className=' p-5'>Contact Us</a></button>
                    </div>
                </div>
                <div className="col-md-3 text-center" data-aos="fade-up" data-aos-delay="500">
                    <div className="shadow pb-5">
                        <div className ="text-center bg-color">
                            <p className="fs-4 fw-bold text-center text-white p-3 fs-3">3 Slice</p>
                        </div>
                        <p className="color text-center"><span className="fw-bold fs-1">$9.00</span>/mo</p>
                        <ul className="p-0 text-center m-0">
                            <li><span>2</span> Cores</li>
                            <li><span> 6GB </span> Memory </li>
                            <li><span> 120GB</span> SSD Storage</li>
                            <li><span>6TB</span> Transfer</li>
                            <li><span>10Gbps</span> Shared Port</li>
                        </ul>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className=' p-5'>Contact Us</a></button>
                    </div>
                </div>
                <div className="col-md-3 text-center" data-aos="fade-up" data-aos-delay="700">
                    <div className="shadow pb-5">
                        <div className ="text-center bg-color">
                            <p className="fs-4 fw-bold text-center text-white p-3 fs-3">4 Slice</p>
                        </div>
                        <p className="color text-center"><span className="fw-bold fs-1">$12.00</span>/mo</p>
                        <ul className="p-0 text-center m-0">
                            <li><span>2</span> Cores</li>
                            <li><span> 8GB </span> Memory </li>
                            <li><span> 160GB</span> SSD Storage</li>
                            <li><span>8TB</span> Transfer</li>
                            <li><span>10Gbps</span> Shared Port</li>
                        </ul>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className=' p-5'>Contact Us</a></button>
                    </div>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col-md-3 text-center" data-aos="fade-up" data-aos-delay="800">
                    <div className="shadow pb-5">
                        <div className ="text-center bg-color">
                            <p className="fs-4 fw-bold text-center text-white  p-3 fs-3">5 Slice</p>
                        </div>
                        <p className="color text-center"><span className="fw-bold fs-1">$15.00</span>/mo</p>
                        <ul className="p-0 text-center m-0">
                            <li><span>3</span> Cores</li>
                            <li><span> 10GB </span> Memory </li>
                            <li><span> 200GB</span> SSD Storage</li>
                            <li><span>10TB</span> Transfer</li>
                            <li><span>10Gbps</span> Shared Port</li>
                        </ul>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className=' p-5'>Contact Us</a></button>
                    </div>
                </div>
                <div className="col-md-3 text-center" data-aos="fade-up" data-aos-delay="1100">
                    <div className="shadow pb-5">
                        <div className ="text-center bg-color">
                            <p className="fs-4 fw-bold text-center text-white p-3 fs-3">6 Slices</p>
                        </div>
                        <p className="color text-center"><span className="fw-bold fs-1">$18.00</span>/mo</p>
                        <ul className="p-0 text-center m-0">
                            <li><span>3</span> Cores</li>
                            <li><span> 12GB </span> Memory </li>
                            <li><span> 240GB</span> SSD Storage</li>
                            <li><span>12TB</span> Transfer</li>
                            <li><span>10Gbps</span> Shared Port</li>
                        </ul>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className=' p-5'>Contact Us</a></button>
                    </div>
                </div>
                <div className="col-md-3 text-center" data-aos="fade-up" data-aos-delay="1300">
                    <div className="shadow pb-5">
                        <div className ="text-center bg-color">
                            <p className="fs-4 fw-bold text-center text-white p-3 fs-3">7 Slice</p>
                        </div>
                        <p className="color text-center"><span className="fw-bold fs-1">$21.00</span>/mo</p>
                        <ul className="p-0 text-center m-0">
                            <li><span>4</span> Cores</li>
                            <li><span> 14GB </span> Memory </li>
                            <li><span> 280GB</span> SSD Storage</li>
                            <li><span>14TB</span> Transfer</li>
                            <li><span>10Gbps</span> Shared Port</li>
                        </ul>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className=' p-5'>Contact Us</a></button>
                    </div>
                </div>
                <div className="col-md-3 text-center" data-aos="fade-up" data-aos-delay="1500">
                    <div className="shadow pb-5">
                        <div className ="text-center bg-color">
                            <p className="fs-4 fw-bold text-center text-white p-3 fs-3">8 Slice</p>
                        </div>
                        <p className="color text-center"><span className="fw-bold fs-1">$24.00</span>/mo</p>
                        <ul className="p-0 text-center m-0">
                            <li><span>4</span> Cores</li>
                            <li><span> 16GB </span> Memory </li>
                            <li><span> 320GB</span> SSD Storage</li>
                            <li><span>16TB</span> Transfer</li>
                            <li><span>10Gbps</span> Shared Port</li>
                        </ul>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className=' p-5'>Contact Us</a></button>
                    </div>
                </div>
            </div>
            <div className="row mt-5" data-aos="fade-up" data-aos-delay="1700">
                <div className="col-md-4 mt-5" >
                    <img src="https://www.interserver.net/vps/assets/images/cloud.png" className="w-100"/>
                </div>
                <div className="col-md-8">
                    <p className="fs-2">Cloud Virtual Private Servers</p>
                    <p>Almalinux deployment with the free Webuzo control panel offering one-click install is a popular choice for popular WordPress VPS. When you buy 4 slices or more we include managed support. Our support can help you diagnose server issues such as database issues or services that are not running. We are available 24/7 by phone, live chat, and ticket system. Another popular choice for working professionals is Windows VPS with remote desktop. Login from all over the world and have all your applications always online and running. No matter what your goals are we would be honored to serve you.</p>
                    <p>Don't forget about backing up data of your vps. A remote storage such as out Cloud Remote Backup Service allow for large amount of storages with the ability to send data over rsync over ssh, SFTP, SCP, FTP over TLS or use Litespeed webserver + php to create a custom backup solution for your files.</p>
                    <ul>
                        <li>* VPS's are upgradable. However most file systems can not shrink with out a reinstall.</li>
                        <li>* Almalinux and Ubuntu OS's use GPT partitioning.</li>
                        <li>* Through a support request extra space can be added as a "second" file system, this is still stored on the same system.</li>
                        <li>* IPs are statically assigned over DHCP and do not change. This config can be modified after initial set up.</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</>
    );
};
 
export default Vpscloud;